var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-chips"},_vm._l((_vm.value),function(chip,chipIndex){return _c('WsChip001',{key:chipIndex,attrs:{"text":chip.text,"leading-icon":chip.icon,"leading-img":chip.image,"color":chip.color,"isWrap":chip.isWrap,"bold":chip.bold}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }